import { KakaoMap } from "./newpla-kakao-map";

declare var kakao: any;

export interface NpCoords {
    x: string;
    y: string;
}
export interface NpAddress {
    addressType: string | 'ROAD_ADDR' | 'REGION_ADDR';
    address1: string;
    address2?: string;
    region1: string;
    region2?: string;
    region3?: string;
    area?: string;
    area1: string;
    area2?: string;
    area3?: string;
    zonecode?: string;
    coords?: NpCoords;
}

export interface KakaoRoadAddress {
    address_name: string | 'ROAD_ADDR' | 'REGION_ADDR';
    region_1depth_name: string;
    region_2depth_name: string;
    region_3depth_name: string;
    x?: string;
    y?: string;
    zone_no: string;
    /////
    road_name: string;
    underground_yn: string;
    building_name?: string;
    main_building_no?: string;
    sub_building_no?: string;
}

export interface KakaoRegionAddress {
    address_name: string;
    region_1depth_name: string;
    region_2depth_name: string;
    region_3depth_name: string;
    x?: string;
    y?: string;
    ///////////////////////
    region_3depth_h_nam?: string;
    mountain_yn?: string;
    underground_yn?: string;
    main_address_no?: string;
    sub_address_no?: string;
    zip_code?: string;
    b_code?: string;
    h_code?: string;

}


export interface KakaoAddress {
    road_address?: KakaoRoadAddress;
    address?: KakaoRegionAddress;
    x?: string;
    y?: string;
    ///////////////
    address_name?: string;
    address_type?: string;
}

export abstract class KakaoMapUtils {

    static panToLatLng(map: KakaoMap.Map, lat: any, lng: any, level = 8) {
        if (!map || !lat || !lng) {
            return;
        }
        // 이동할 위도 경도 위치를 생성합니다 
        const latLng = KakaoMap.newLatLng(lat, lng);
        // var moveLatLon = new kakao.maps.LatLng(lat, lng);
        // 지도 중심을 부드럽게 이동시킵니다
        // 만약 이동할 거리가 지도 화면보다 크면 부드러운 효과 없이 이동합니다
        if (map.getLevel() >= 8) {
            map.setLevel(8);
        }
        map.panTo(latLng);
    }

    static kakao2NpAddressWithZonecode(kakaoAddr: KakaoAddress, zonecode: string): NpAddress {
        if (!zonecode) {
            throw Error("우편번호가 없습니다.");
        }

        let coords!: NpCoords;

        if (kakaoAddr.x && kakaoAddr.y) {
            coords = { x: kakaoAddr.x, y: kakaoAddr.y }
        }

        if (kakaoAddr.road_address) {

            if (kakaoAddr.road_address.x && kakaoAddr.road_address.y) {
                coords = { x: kakaoAddr.road_address.x, y: kakaoAddr.road_address.y }
            }

            // 도로명 주소인 경우
            let npAddress: NpAddress = {
                addressType: 'ROAD_ADDR',
                address1: kakaoAddr.road_address.address_name,
                region1: kakaoAddr.road_address.region_1depth_name,
                region2: kakaoAddr.road_address.region_2depth_name,
                region3: kakaoAddr.road_address.region_3depth_name,
                area1: kakaoAddr.road_address.region_1depth_name,
                area2: kakaoAddr.road_address.region_2depth_name,
                area3: kakaoAddr.road_address.region_3depth_name,
                zonecode: kakaoAddr.road_address.zone_no ?? kakaoAddr.road_address.zone_no ? kakaoAddr.road_address.zone_no : zonecode,
                coords
            }
            npAddress.area = KakaoMapUtils.toSimpleArea(npAddress.region1, npAddress.region2);
            return npAddress;

        } else if (kakaoAddr.address) {

            if (kakaoAddr.address.x && kakaoAddr.address.y) {
                coords = { x: kakaoAddr.address.x, y: kakaoAddr.address.y }
            }

            let npAddress: NpAddress = {
                addressType: 'REGION_ADDR',
                address1: kakaoAddr.address.address_name,
                region1: kakaoAddr.address.region_1depth_name,
                region2: kakaoAddr.address.region_2depth_name,
                region3: kakaoAddr.address.region_3depth_name,
                area1: kakaoAddr.address.region_1depth_name,
                area2: kakaoAddr.address.region_2depth_name,
                area3: kakaoAddr.address.region_3depth_name,
                zonecode, coords
            }
            npAddress.area = KakaoMapUtils.toSimpleArea(npAddress.region1, npAddress.region2);
            return npAddress;
        } else {
            throw Error("주소 파싱에 실패했습니다.");
        }

    }

    static kakao2NpAddressWithCoords(kakaoAddr: KakaoAddress, coords: NpCoords): NpAddress {

        if (!coords) {
            throw Error("좌표 정보가 없습니다.");
        }

        if (kakaoAddr.road_address) {
            // 도로명 주소인 경우
            let npAddress: NpAddress = {
                addressType: 'ROAD_ADDR',
                address1: kakaoAddr.road_address.address_name,
                region1: kakaoAddr.road_address.region_1depth_name,
                region2: kakaoAddr.road_address.region_2depth_name,
                region3: kakaoAddr.road_address.region_3depth_name,
                area1: kakaoAddr.road_address.region_1depth_name,
                area2: kakaoAddr.road_address.region_2depth_name,
                area3: kakaoAddr.road_address.region_3depth_name,
                zonecode: kakaoAddr.road_address.zone_no,
                coords: coords
            }
            npAddress.area = KakaoMapUtils.toSimpleArea(npAddress.region1, npAddress.region2);
            return npAddress;

        } else if (kakaoAddr.address) {
            let npAddress: NpAddress = {
                addressType: 'REGION_ADDR',
                address1: kakaoAddr.address.address_name,
                region1: kakaoAddr.address.region_1depth_name,
                region2: kakaoAddr.address.region_2depth_name,
                region3: kakaoAddr.address.region_3depth_name,
                area1: kakaoAddr.address.region_1depth_name,
                area2: kakaoAddr.address.region_2depth_name,
                area3: kakaoAddr.address.region_3depth_name,
                coords: coords
            }
            npAddress.area = KakaoMapUtils.toSimpleArea(npAddress.region1, npAddress.region2);
            return npAddress;
        } else {
            throw Error("주소 파싱에 실패했습니다.");
        }
    }

    static toSimpleArea(region1: string, region2?: string) {
        const temp1 = region1.length > 2 ? region1.substring(0, 2) : region1;
        if (region2) {
            const temp2 = region2.split(" ")[0];
            if (temp1 !== temp2) {
                return temp1 + " " + temp2;
            } else {
                return temp1;
            }
        } else {
            return temp1;
        }
    }

    // static getMarkerImageByStatus(status: string): any {

    //     switch (status) {
    //         case 'CREATED':
    //             return new kakao.maps.MarkerImage('/assets/images/map/marker/marker-white.png',
    //                 new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
    //         case 'CENTER_ALLOCATED':
    //             return new kakao.maps.MarkerImage('/assets/images/map/marker/marker-white.png',
    //                 new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
    //         case 'ASSIGNED':
    //             return new kakao.maps.MarkerImage('/assets/images/map/marker/marker-orange.png',
    //                 new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
    //         case 'IN_PROCESSING':
    //             return new kakao.maps.MarkerImage('/assets/images/map/marker/marker-blue.png',
    //                 new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
    //         case 'COMPLETED':
    //             return new kakao.maps.MarkerImage('/assets/images/map/marker/marker-green.png',
    //                 new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
    //         case 'CANCELED':
    //             return new kakao.maps.MarkerImage('/assets/images/map/marker/marker-gray.png',
    //                 new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
    //     }

    // }

    static setWhiteTileSet(map: any) {
        // Tileset을 생성하고 지도 오버레이로 추가합니다
        kakao.maps.Tileset.add('TILE_NUMBER',
            new kakao.maps.Tileset({
                width: 256,
                height: 256,
                getTile: function (x: any, y: any, z: any) {
                    var div = document.createElement('div');
                    div.style.backgroundColor = "#fff";
                    div.style.opacity = "0.4";
                    return div;
                }
            }));

        // 지도 위에 TILE_NUMBER 오버레이 레이어를 추가합니다
        map.addOverlayMapTypeId(kakao.maps.MapTypeId.TILE_NUMBER);
    }

    static getMarkerImageByColor(color: string): any {

        switch (color) {
            case 'CYAN':
                return new kakao.maps.MarkerImage('/assets/kakaomap/marker/marker-cyan.png',
                    new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
            case 'RED':
                return new kakao.maps.MarkerImage('/assets/kakaomap/marker/marker-red.png',
                    new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
            case 'PINK':
                return new kakao.maps.MarkerImage('/assets/kakaomap/marker/marker-pink.png',
                    new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
            case 'ORANGE':
                return new kakao.maps.MarkerImage('/assets/kakaomap/marker/marker-orange.png',
                    new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
            case 'ORANGE_NO_OUTLINE':
                return new kakao.maps.MarkerImage('/assets/kakaomap/marker/marker-orange-no-outline.png',
                    new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
            case 'YELLOW60':
                return new kakao.maps.MarkerImage('/assets/kakaomap/marker/marker-yellow60.png',
                    new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
            case 'YELLOW40':
                return new kakao.maps.MarkerImage('/assets/kakaomap/marker/marker-yellow40.png',
                    new kakao.maps.Size(32, 32), new kakao.maps.Point(16, 26));
        }

    }

    // static markerImage = {
    //     logisCenter: new kakao.maps.MarkerImage('/assets/images/map/marker/marker-black.png', new kakao.maps.Size(12, 20), new kakao.maps.Point(24, 44)),
    //     selected: new kakao.maps.MarkerImage('/assets/images/map/marker/marker-white.png',
    //         new kakao.maps.Size(24, 24), new kakao.maps.Point(12, 20))
    // }

}